import React from "react";

const Publications: React.FC = () => {
  return (
    <section className="section active">
      {/* Hero section with image */}
      <div className="hero">
        <h1>Publications</h1>
        <img
          src="/images/Best-Paper-Award-Academy-Marketing-Science-Alex-Mari.jpg"
          alt="Dr. Alex Mari - Publications"
          className="hero-image"
        />
      </div>

      {/* Main content with consistent spacing */}
      <div className="bio">
        <h2>Published Research</h2>

        <h3>Peer-Reviewed Article (2)</h3>
        <div className="publication-list">
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(2)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong>, Mandelli A. & Algesheimer R. (2025){" "}
              <em>
                AI-Assisted Shopping on Voice Assistants: The Efficiency-Autonomy Consumer Decision Trade-Off
              </em>
              . Journal of Interactive Marketing.{" "}
              <a
                href="/publications/AI-Assisted-Shopping-on-Voice-Assistants-The-Efficiency-Autonomy-Consumer-Decision-Trade-Off_2025_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://journals.sagepub.com/doi/10.1177/10949968251400616"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(1)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong>, Mandelli A. & Algesheimer R. (2024){" "}
              <em>
                Empathic voice assistants: Enhancing consumer responses in voice
                commerce
              </em>
              . Journal of Business Research, 175, 114566.{" "}
              <a
                href="/publications/Empathic-voice-assistants-Enhancing-consumer-responses-in-voice-commerce_2024_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://www.sciencedirect.com/science/article/pii/S0148296324000705"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
        </div>

        <h3>Invited Book Chapter and Business Magazine (6)</h3>
        <div className="publication-list">
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(6)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong>, Mandelli A. & Algesheimer R. (2025){" "}
              <em>
                Harnessing AI Voice Assistants for Digital Corporate
                Communication
              </em>
              . Corporate Communication Review, 1 (1), 40-45.{" "}
              <a
                href="/publications/Harnessing-AI-voice-assistants-for-digital-corporate-communication_2025_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://www.corpcommreview.com/corpcommreview/article/view/10/9"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(5)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong>, Mandelli A. & Algesheimer R. (2023){" "}
              <em>Digital Corporate Communication and Voice Communication</em>.
              In Luoma-aho and Badham (eds.) Handbook of Digital Corporate
              Communication, Edward Elgar, 343-356.{" "}
              <a
                href="/publications/Digital-Corporate-Communication-and-Voice-Communication_2023_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://www.zora.uzh.ch/id/eprint/233923/1/Book-Chapter_DCC-Voice_Pre-print_2023.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(4)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong> & Algesheimer R. (2021){" "}
              <em>
                AI-based Voice Assistants for Digital Marketing: Preparing for
                Voice Marketing and Commerce
              </em>
              . In Contemporary Issues in Digital Marketing, Routledge, UK.{" "}
              <a
                href="/publications/AI-based-voice-assistants-for-digital-marketing_2021_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://www.zora.uzh.ch/id/eprint/208002/1/AI-based-voice-assistants-for-digital-marketing_mari-algesheimer_2021.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(3)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong> (2016){" "}
              <em>
                The impact of social media on consumer-brand relationships
              </em>
              . In Karmarkar and Mangal (eds.) The UCLA Anderson Business and
              Information Technologies (BIT) Project: A Global Study of Business
              Practice. World Scientific Publishing Company.{" "}
              <a
                href="/publications/Impact-of-social-media-on-consumer-brand-relationships_2016_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://www.researchgate.net/publication/332606564_Impact_of_social_media_on_consumer-brand_relationships"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(2)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Mandelli A. & <strong>Mari A.</strong> (2012){" "}
              <em>
                The impact of digital technology on service networks: studying a
                case in the advertising sector
              </em>
              . In Karmarkar and Mangal (eds.) The UCLA Anderson Business and
              Information Technologies (BIT) Project: A Global Study of Business
              Practice. World Scientific Publishing Company.{" "}
              <a
                href="/publications/The-impact-of-digital-technology-on-service-networks_2012_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://www.worldscientific.com/doi/abs/10.1142/9789814390880_0008"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(1)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Mandelli A., Accoto C. & <strong>Mari A.</strong> (2010){" "}
              <em>
                Pratiche di social media measurement: esplorazione e modelli
              </em>
              . In A. Mandelli and C. Accoto (eds.), Marca e Metriche nei Social
              Media, Lugano, CH: Università della Svizzera italiana, 135 -167.
            </span>
          </div>
        </div>

        <h3>Conference Proceeding (9)</h3>
        <div className="publication-list">
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(9)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong> & Alabed A. (2025){" "}
              <em>
                AI with a Conscience: Empathic Voice Assistants for Sustainable
                Shopping Decisions
              </em>
              . International Conference on Sustainability and Innovation
              Processes and Systems. Springer.{" "}
              <a
                href="/publications/AI-with-a-Conscience-Empathic-Voice-Assistants-for-Sustainable-Shopping-Decisions_2025_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(8)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong>, Mandelli A. & Algesheimer R. (2022){" "}
              <em>
                Shopping with Voice Assistants: How Empathy Affects
                Decision-Making Outcomes: An Abstract
              </em>
              . In Academy of Marketing Science Annual Conference (pp. 39-40).
              Cham: Springer Nature Switzerland.
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(7)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong> (2022){" "}
              <em>
                Artificial Intelligence-based Voice Assistants as Social Media
                Platform: Anticipated Effect on Brands During Shopping
              </em>
              . Journal of Creative Industries and Cultural Studies: JOCIS, (6),
              56-71.{" "}
              <a
                href="/publications/Artificial-Intelligence-based-Voice-Assistants-as-Social-Media-Platform_2022_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="http://eprints.rclis.org/43315/"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(6)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong> & Algesheimer, R. (2021){" "}
              <em>
                The Role of Trusting Beliefs in Voice Assistants during Voice
                Shopping
              </em>
              . In Proceedings of the 54th Hawaii International Conference on
              System Sciences, pp. 4073 - 4082.{" "}
              <a
                href="/publications/The-Role-of-Trusting-Beliefs-in-Voice-Assistants-during-Voice-Shopping_2021_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://scholarspace.manoa.hawaii.edu/items/e97f69d1-1226-4d47-8f22-c5f355cd964b"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(5)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong>, Mandelli A. & Algesheimer R. (2020){" "}
              <em>
                The Evolution of Marketing in the Context of Voice Commerce: A
                Managerial Perspective
              </em>
              . In: Nah FH., Siau K. (eds) HCI in Business, Government and
              Organizations. HCII 2020. Lecture Notes in Computer Science, vol
              12204. Springer, Cham.{" "}
              <a
                href="/publications/The-Evolution-of-Marketing-in-the-Context-of-Voice-Commerce_2020_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://link.springer.com/chapter/10.1007/978-3-030-50341-3_32"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(4)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong> (2019){" "}
              <em>
                Voice Commerce: Understanding shopping-related voice assistants
                and their effect on brands
              </em>
              . In IMMAA Annual Conference. Northwestern University in Qatar,
              Doha (Qatar).{" "}
              <a
                href="/publications/Voice-Commerce-Understanding-Shopping-Related-Voice-Assistants-and-their-Effect-on-Brands_2019_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://www.zora.uzh.ch/id/eprint/197725/1/VoiceCommerce_VoiceAssistants_AlexMari_UZH_2019.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(3)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong> (2019){" "}
              <em>
                The Rise of Machine Learning in Marketing: Goal, Process, and
                Benefit of AI-Driven Marketing
              </em>
              . Research Report, University of Zurich. DOI: 10.13140
              /RG.2.2.16328.16649.{" "}
              <a
                href="/publications/The-Rise-of-Machine-Learning-in-Marketing-Goal-Process-Benefit-AI-Driven-Marketing_2019_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://www.zora.uzh.ch/id/eprint/197751/1/TheRiseofMachineLearning_ResearchReport_AlexMari_2019.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(2)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Mandelli A. & <strong>Mari A.</strong> (2011){" "}
              <em>
                The relationship between social media conversations and
                reputation during a crisis: The Toyota case
              </em>
              . International Journal of Management Cases, 456 - 489, 14 (1).{" "}
              <a
                href="/publications/The-relationship-between-social-media-conversations-and-reputation-during-a-crisis-The-Toyota-case_2011_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://www.researchgate.net/publication/263571785_THE_RELATIONSHIP_BETWEEN_SOCIAL_MEDIA_CONVERSATIONS_AND_REPUTATION_DURING_A_CRISIS_THE_TOYOTA_CASE"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(1)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Mandelli A., Accoto C. & <strong>Mari A.</strong> (2010){" "}
              <em>
                Social Media Metrics: Practices of Measuring Brand equity and
                Reputation in Online Social Collectives
              </em>
              . 6th International conference 'Thought leaders in Brand
              Management', Università della Svizzera Italiana, Lugano,
              Switzerland.
            </span>
          </div>
        </div>

        <h2>Completed Research</h2>

        <h3>Peer-Reviewed Article (5)</h3>
        <div className="publication-list">
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(5)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Uysal, E., Alavi, S., Brooks, J., <strong>Mari, A.</strong>, & Efthymiou, F. (under review){" "}
              <em>
                The Voice of Emotion: Advancing Marketing Research Through Real-Time AI Emotion Measurements
              </em>
              .{" "}
              <a
                href="/publications/The-Voice-of-Emotion-Advancing-Marketing-Research-Through-Real-Time-AI-Emotion-Measurements_2025_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=5909843"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(4)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari, A.</strong>, Uysal, D. E., Alabed, A., Efthymiou, F., & Brooks, J. (under review){" "}
              <em>
                Generative AI-Enabled Empathy and Persuasion in Voice Assistants: Impact on Sustainable Consumer Choice
              </em>
              .{" "}
              <a
                href="/publications/Generative-AI-Enabled-Empathy-and-Persuasion-in-Voice-Assistants-Impact-on-Sustainable-Consumer-Choice_2025_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=5420076"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(3)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari, A.</strong>, Uysal, D. E., Alabed, A., Efthymiou, F., & Brooks, J. (under review){" "}
              <em>
                Generative AI-Enabled Empathy and Persuasion in Voice Assistants: Impact on Sustainable Consumer Choice
              </em>
              .{" "}
              <a
                href="/publications/Generative-AI-Enabled-Empathy-and-Persuasion-in-Voice-Assistants-Impact-on-Sustainable-Consumer-Choice_2025_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=5420076"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(2)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              Efthymiou F., <strong>Mari A.</strong>, Uysal E. & Brooks, J.
              (under review){" "}
              <em>
                No Hard Feelings: The Protective Power of AI Empathy During
                Service Interaction Failures
              </em>
              .{" "}
              <a
                href="/publications/No-Hard-Feelings-The-Protective-Power-of-AI-Empathy-During-Service-Interaction-Failures_2025_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://doi.org/10.31234/osf.io/4n9xy_v1"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
          <div className="publication-item">
            <span style={{ minWidth: "40px", flexShrink: 0 }}>(1)</span>
            <span style={{ paddingLeft: "20px", flex: 1 }}>
              <strong>Mari A.</strong>, Mandelli A. & Algesheimer R. (under
              review){" "}
              <em>
                Fear of Missing Out (FOMO) on Emerging AI Technology: Biased and
                Unbiased Adoption Decision Making
              </em>
              .{" "}
              <a
                href="/publications/Fear-of-Missing-Out-FOMO-on-Emerging-AI-Technology-Biased-and-Unbiased-Adoption-Decision-Making_2025_Dr-Alex-Mari.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="pdf-link"
              >
                PDF
              </a>{" "}
              <a
                href="https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4736154"
                target="_blank"
                rel="noopener noreferrer"
                className="navigation-arrow"
              >
                {">>"}
              </a>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Publications;
